(() => {
  'use strict';
  const mobile = window.matchMedia('(max-width: 767px)');
  const home = document.body.classList.contains('template-index') && document.getElementById('nt_content');
  if (home) {
    const originalSections = Array.from(home.children);
    const syncReadingOrder = () => {
      const sections = mobile.matches
        ? originalSections.slice().sort((a, b) => Number(getComputedStyle(a).order) - Number(getComputedStyle(b).order))
        : originalSections;
      const currentSections = Array.from(home.children);
      if (sections.some((section, index) => currentSections[index] !== section)) home.append(...sections);
    };
    syncReadingOrder();
    mobile.addEventListener('change', syncReadingOrder);
  }
  const bar = document.querySelector('[data-bfg-personalize-bar]');
  const summary = document.getElementById('shopify-section-pr_summary');
  if (!bar || !summary) return;
  const priceOutput = bar.querySelector('[data-bfg-selected-price]');
  const trigger = bar.querySelector('[data-bfg-personalize-trigger]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let frame = 0;
  let actions = null;
  let actionsVisible = false;
  const intersection = new IntersectionObserver(entries => {
    actionsVisible = entries.some(entry => entry.isIntersecting);
    schedule();
  }, { rootMargin: '0px 0px -90px 0px', threshold: 0 });
  function refresh() {
    frame = 0;
    const form = summary.querySelector('#tee-artwork-form');
    // Native actions can remain fixed on screen even while the options are below the fold.
    const nextActions = summary.querySelector('#teeFormInputs') || summary.querySelector('#teeFormActions');
    const price = summary.querySelector('.tee-price--current');
    if (nextActions !== actions) {
      intersection.disconnect();
      actions = nextActions;
      actionsVisible = false;
      if (actions) intersection.observe(actions);
    }
    const text = price ? price.textContent.trim() : '';
    if (priceOutput.textContent !== text) priceOutput.textContent = text;
    bar.hidden = !mobile.matches || !form || !actions || !text || actionsVisible;
  }
  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(refresh);
  }
  trigger.addEventListener('click', () => {
    const target = summary.querySelector('#teeFormInputs') || summary.querySelector('#tee-artwork-form');
    if (!target) return;
    const header = document.getElementById('ntheader');
    const stickyHeight = header ? Math.min(header.getBoundingClientRect().height, 130) : 70;
    const top = target.getBoundingClientRect().top + window.scrollY - stickyHeight - 12;
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    window.scrollTo({ top: Math.max(0, top), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
  });
  const mutation = new MutationObserver(schedule);
  mutation.observe(summary, { subtree: true, childList: true, characterData: true });
  mobile.addEventListener('change', schedule);
  window.addEventListener('pageshow', schedule);
  refresh();
})();
